import PropTypes from 'prop-types';
import React from 'react';

import { WHITE } from '@wetransfer/transfer/constant/colors';

const Fallback = ({ className, color }) => (
  <svg width="33" height="33" viewBox="0 0 33 33" className={className}>
    <path
      fill={color}
      d="M.828 2.95A1.5 1.5 0 0 1 2.95.828l29.346 29.347a1.5 1.5 0 1 1-2.121 2.121L.828 2.95z"
    />
  </svg>
);

Fallback.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Fallback.defaultProps = {
  color: WHITE,
};

export default Fallback;
